import React, {useEffect, useState} from 'react';
import './styles.scss';
import * as Yup from 'yup';
import {strings} from '../../util/strings';
import {compose} from 'redux';
import {connect} from 'react-redux';
import AppWrapper from '../../components/app-wrapper';
import {Column, Row} from '../../components/layout';
import Header1 from '../../components/headers/header1';
import * as fonts from '../../util/fonts';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from './components/TabPanel';
import colors from '../../util/colors';
import {addToWizard, setWizard} from '../../store/actions';
import AdvanceCareTab from './components/advancecare-tab/AdvanceCareTab';
import MeuSeguroTab from './components/my-insurance-tab/MyInsuranceTab';
import Icon from '../../components/icon';
import {Icons} from '../../util/icons';

interface PermissionsProps {
  user: any;
  titular: any;
  selectedBu: any;
  availableBus: any;
  wizard: any;
  buStyles: any;
  setWizard(value: any): void;
  addToWizard(value: any): void;
  labels: typeof strings.pt.register;
  labelsPermissions: typeof strings.pt.permissions;
  oneTrust: typeof strings.pt.oneTrust;
  purposes: any;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

const validationSchema = Yup.object().shape({
  termsAccepted: Yup.boolean().required(),
  privacyPolicyAccepted: Yup.boolean().required(),
});

function Permissions({
  user,
  selectedBu,
  availableBus,
  labels,
  labelsPermissions,
  wizard,
  buStyles,
  titular,
  setWizard,
  purposes,
  addToWizard,
  oneTrust,
}: PermissionsProps) {
  const [tabValue, setTabValue] = useState(0);

  const handleTab = (event: React.ChangeEvent<{}>, value: any) => {
    setTabValue(value);
  };

  const tabIndicatorStyle = {style: {backgroundColor: 'transparent'}};
  const tabIndicatorMinHeight = {minHeight: '30px'};
  const permissionsTabsTitles = {
    ...fonts.M,
    ...fonts.Bold,
    paddingBottom: '12px',
    color: tabValue === 0 ? colors.white : buStyles.primaryColor,
  };
  const permissionsTabsTitlesNotClient = {
    ...fonts.M,
    ...fonts.Bold,
    paddingBottom: '12px',
    color: tabValue === 1 ? colors.white : buStyles.primaryColor,
  };

  const notAllowedComponent = () => {
    return (
      <Column className="permissions-not-allowed">
        <Icon
          className="reimbursement-no-results-history-filter-icon"
          name={Icons.ALERT_PROBLEM}
          color={colors.lightGrey}
          width="40"
          height="40"
          changeViewbox
          viewBox={'0 0 24 24'}
        />
        <h6
          className="reimbursement-list-header"
          style={{color: colors.lightGrey, fontFamily: 'Poppins'}}>
          {labelsPermissions?.permissions_not_allowed_to_manage}
        </h6>
      </Column>
    );
  };

  return (
    <>
      <Row className="reimbursement-history-titlerow reimbursement-history-row">
        <Column className="reimbursement-history-titlecolumn">
          <Header1
            className="reimbursement-history-heading1 talk-with-us-heading"
            style={{...fonts.XL, ...fonts.Bold}}>
            {labelsPermissions.permissions_title}
          </Header1>
          <label style={{...fonts.M}}>
            {(labelsPermissions.permissions_advancecare_active === '1' ||
              labelsPermissions.permissions_myinsurance_active === '1') &&
              labelsPermissions.permissions_subtitle}
          </label>
          <Row>
            {labelsPermissions.permissions_advancecare_active === '1' ||
            labelsPermissions.permissions_myinsurance_active === '1' ? (
              <div className="tabs">
                <Tabs
                  className="permissions-tab-parent"
                  value={tabValue}
                  orientation="horizontal"
                  onChange={handleTab}
                  indicatorColor="primary"
                  TabIndicatorProps={tabIndicatorStyle}
                  style={tabIndicatorMinHeight}>
                  {labelsPermissions.permissions_advancecare_active === '1' && (
                    <Tab
                      className="permissions-tab"
                      label={
                        <span style={permissionsTabsTitles}>
                          {labelsPermissions.permissions_advancecare_title}
                        </span>
                      }
                      wrapped={false}
                    />
                  )}
                  {user.state !== 'NOTCLIENT' &&
                    labelsPermissions.permissions_myinsurance_active ===
                      '1' && (
                      <Tab
                        className="permissions-tab"
                        label={
                          <span style={permissionsTabsTitlesNotClient}>
                            {labelsPermissions.permissions_myinsurance_title}
                          </span>
                        }
                        wrapped={false}
                      />
                    )}
                </Tabs>
                <div
                  className="permissions-separator"
                  style={{backgroundColor: colors.black, height: '2px'}}
                />
                {labelsPermissions.permissions_advancecare_active === '1' && (
                  <TabPanel value={tabValue} index={0}>
                    <AdvanceCareTab />
                  </TabPanel>
                )}
                {user.state !== 'NOTCLIENT' &&
                  labelsPermissions.permissions_myinsurance_active === '1' && (
                    <TabPanel
                      value={tabValue}
                      index={
                        labelsPermissions.permissions_advancecare_active === '0'
                          ? 0
                          : 1
                      }>
                      <div className="meu-seguro-tab">
                        <MeuSeguroTab />
                      </div>
                    </TabPanel>
                  )}
              </div>
            ) : (
              notAllowedComponent()
            )}
          </Row>
        </Column>
      </Row>
    </>
  );
}

const mapStateToProps = ({
  selectedBu,
  user,
  strings,
  wizard,
  availableBus,
  globalStyles,
  titular,
  purposes,
}: any) => ({
  user: user.value,
  selectedBu: selectedBu.value,
  availableBus: availableBus.value,
  labels: strings.value.pt.register,
  labelsPermissions: strings.value.pt.permissions,
  oneTrust: strings.value.pt.oneTrust,
  wizard: wizard.value,
  buStyles: globalStyles.value,
  titular: titular.value,
  purposes: purposes.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(Permissions)
);
